import React from "react";
import { Offcanvas, Table } from "react-bootstrap";
import Moment from "react-moment";

const FileDataProperties = ({ tableRef, onMouseDown, Show, Hide, Title, projectData }) => {
  return (
    <div>
      <Offcanvas
        show={Show}
        onHide={Hide}
        style={{ width: 600 }}
        placement="end"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-0">
          <Table ref={tableRef} className="m-0 custom-table" hover striped>
            <thead className="position-sticky top-0">
              <tr>
                <th onMouseDown={(e) => onMouseDown(e, 0)}>Attribute</th>
                <th onMouseDown={(e) => onMouseDown(e, 1)}>Value</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Name</td>
                <td>{projectData?.name}</td>
              </tr>
              {projectData?.keepFile !== "system" &&
                <>
                  <tr>
                    <td>Description</td>
                    <td>{projectData?.description}</td>
                  </tr>
                  <tr>
                    <td>Location</td>
                    <td title={`${projectData?.path}${projectData?.type === "file" && `.${projectData?.extension}`}`}>
                      {projectData?.path}{projectData?.type === "file" && `.${projectData?.extension}`}
                    </td>
                  </tr>
                </>
              }
              {projectData?.keepFile === "system" &&
                <>
                  <tr>
                    <td>Location</td>
                    <td>{projectData?.fullFilePath}.{projectData?.extension}</td>
                  </tr>
                  <tr>
                    <td>Old Extension</td>
                    <td>{projectData?.oldExtension}</td>
                  </tr>
                </>
              }
              <tr>
                <td>Keep File</td>
                <td className="text-capitalize">{projectData?.keepFile || "Server"}</td>
              </tr>
              {projectData?.keepFile !== "system" &&
                <>
                  <tr>
                    <td>Rows</td>
                    <td>{projectData?.row}</td>
                  </tr>
                  <tr>
                    <td>Columns</td>
                    <td>{projectData?.column}</td>
                  </tr>
                </>
              }
              <tr>
                <td>Created Date | Time</td>
                <td>
                  <Moment format="DD MMM YYYY | HH:mm:ss" withTitle>
                    {projectData?.createdAt}
                  </Moment>
                </td>
              </tr>
              <tr>
                <td>Modified Date | Time</td>
                <td>
                  <Moment format="DD MMM YYYY | HH:mm:ss" withTitle>
                    {projectData?.updatedAt}
                  </Moment>
                </td>
              </tr>
            </tbody>
          </Table>
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
};

export default FileDataProperties;
